import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
import personalInfo5c22df from './personal-info'
import aboutMe4f841e from './about-me'
import media30b75d from './media'
import subjectsC258ee from './subjects'
import levels825db0 from './levels'
import examboards41b059 from './examboards'
import experience39e637 from './experience'
import teachingDetails8077ab from './teaching-details'
import pricingCf18cb from './pricing'
import availability135fa0 from './availability'
import qualifications98d403 from './qualifications'
import documentsC2fd24 from './documents'
import bankDetails824b2d from './bank-details'
import notifications1ce82a from './notifications'
/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::index
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:27
* @route '/teacher/settings'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/teacher/settings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::index
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:27
* @route '/teacher/settings'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::index
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:27
* @route '/teacher/settings'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::index
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:27
* @route '/teacher/settings'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::personalInfo
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:32
* @route '/teacher/settings/personal-info'
*/
export const personalInfo = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: personalInfo.url(options),
    method: 'get',
})

personalInfo.definition = {
    methods: ["get","head"],
    url: '/teacher/settings/personal-info',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::personalInfo
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:32
* @route '/teacher/settings/personal-info'
*/
personalInfo.url = (options?: RouteQueryOptions) => {
    return personalInfo.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::personalInfo
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:32
* @route '/teacher/settings/personal-info'
*/
personalInfo.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: personalInfo.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::personalInfo
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:32
* @route '/teacher/settings/personal-info'
*/
personalInfo.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: personalInfo.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::aboutMe
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:42
* @route '/teacher/settings/about-me'
*/
export const aboutMe = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: aboutMe.url(options),
    method: 'get',
})

aboutMe.definition = {
    methods: ["get","head"],
    url: '/teacher/settings/about-me',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::aboutMe
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:42
* @route '/teacher/settings/about-me'
*/
aboutMe.url = (options?: RouteQueryOptions) => {
    return aboutMe.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::aboutMe
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:42
* @route '/teacher/settings/about-me'
*/
aboutMe.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: aboutMe.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::aboutMe
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:42
* @route '/teacher/settings/about-me'
*/
aboutMe.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: aboutMe.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::media
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:52
* @route '/teacher/settings/media'
*/
export const media = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: media.url(options),
    method: 'get',
})

media.definition = {
    methods: ["get","head"],
    url: '/teacher/settings/media',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::media
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:52
* @route '/teacher/settings/media'
*/
media.url = (options?: RouteQueryOptions) => {
    return media.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::media
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:52
* @route '/teacher/settings/media'
*/
media.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: media.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::media
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:52
* @route '/teacher/settings/media'
*/
media.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: media.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::subjects
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:130
* @route '/teacher/settings/subjects'
*/
export const subjects = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: subjects.url(options),
    method: 'get',
})

subjects.definition = {
    methods: ["get","head"],
    url: '/teacher/settings/subjects',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::subjects
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:130
* @route '/teacher/settings/subjects'
*/
subjects.url = (options?: RouteQueryOptions) => {
    return subjects.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::subjects
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:130
* @route '/teacher/settings/subjects'
*/
subjects.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: subjects.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::subjects
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:130
* @route '/teacher/settings/subjects'
*/
subjects.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: subjects.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::levels
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:142
* @route '/teacher/settings/levels'
*/
export const levels = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: levels.url(options),
    method: 'get',
})

levels.definition = {
    methods: ["get","head"],
    url: '/teacher/settings/levels',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::levels
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:142
* @route '/teacher/settings/levels'
*/
levels.url = (options?: RouteQueryOptions) => {
    return levels.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::levels
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:142
* @route '/teacher/settings/levels'
*/
levels.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: levels.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::levels
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:142
* @route '/teacher/settings/levels'
*/
levels.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: levels.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::examboards
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:154
* @route '/teacher/settings/examboards'
*/
export const examboards = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: examboards.url(options),
    method: 'get',
})

examboards.definition = {
    methods: ["get","head"],
    url: '/teacher/settings/examboards',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::examboards
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:154
* @route '/teacher/settings/examboards'
*/
examboards.url = (options?: RouteQueryOptions) => {
    return examboards.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::examboards
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:154
* @route '/teacher/settings/examboards'
*/
examboards.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: examboards.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::examboards
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:154
* @route '/teacher/settings/examboards'
*/
examboards.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: examboards.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::experience
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:166
* @route '/teacher/settings/experience'
*/
export const experience = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: experience.url(options),
    method: 'get',
})

experience.definition = {
    methods: ["get","head"],
    url: '/teacher/settings/experience',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::experience
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:166
* @route '/teacher/settings/experience'
*/
experience.url = (options?: RouteQueryOptions) => {
    return experience.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::experience
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:166
* @route '/teacher/settings/experience'
*/
experience.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: experience.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::experience
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:166
* @route '/teacher/settings/experience'
*/
experience.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: experience.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::teachingDetails
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:178
* @route '/teacher/settings/teaching-details'
*/
export const teachingDetails = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: teachingDetails.url(options),
    method: 'get',
})

teachingDetails.definition = {
    methods: ["get","head"],
    url: '/teacher/settings/teaching-details',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::teachingDetails
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:178
* @route '/teacher/settings/teaching-details'
*/
teachingDetails.url = (options?: RouteQueryOptions) => {
    return teachingDetails.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::teachingDetails
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:178
* @route '/teacher/settings/teaching-details'
*/
teachingDetails.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: teachingDetails.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::teachingDetails
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:178
* @route '/teacher/settings/teaching-details'
*/
teachingDetails.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: teachingDetails.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::pricing
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:278
* @route '/teacher/settings/pricing'
*/
export const pricing = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pricing.url(options),
    method: 'get',
})

pricing.definition = {
    methods: ["get","head"],
    url: '/teacher/settings/pricing',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::pricing
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:278
* @route '/teacher/settings/pricing'
*/
pricing.url = (options?: RouteQueryOptions) => {
    return pricing.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::pricing
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:278
* @route '/teacher/settings/pricing'
*/
pricing.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pricing.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::pricing
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:278
* @route '/teacher/settings/pricing'
*/
pricing.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: pricing.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::availability
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:314
* @route '/teacher/settings/availability'
*/
export const availability = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: availability.url(options),
    method: 'get',
})

availability.definition = {
    methods: ["get","head"],
    url: '/teacher/settings/availability',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::availability
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:314
* @route '/teacher/settings/availability'
*/
availability.url = (options?: RouteQueryOptions) => {
    return availability.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::availability
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:314
* @route '/teacher/settings/availability'
*/
availability.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: availability.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::availability
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:314
* @route '/teacher/settings/availability'
*/
availability.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: availability.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::qualifications
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:483
* @route '/teacher/settings/qualifications'
*/
export const qualifications = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: qualifications.url(options),
    method: 'get',
})

qualifications.definition = {
    methods: ["get","head"],
    url: '/teacher/settings/qualifications',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::qualifications
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:483
* @route '/teacher/settings/qualifications'
*/
qualifications.url = (options?: RouteQueryOptions) => {
    return qualifications.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::qualifications
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:483
* @route '/teacher/settings/qualifications'
*/
qualifications.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: qualifications.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::qualifications
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:483
* @route '/teacher/settings/qualifications'
*/
qualifications.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: qualifications.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::documents
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:523
* @route '/teacher/settings/documents'
*/
export const documents = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: documents.url(options),
    method: 'get',
})

documents.definition = {
    methods: ["get","head"],
    url: '/teacher/settings/documents',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::documents
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:523
* @route '/teacher/settings/documents'
*/
documents.url = (options?: RouteQueryOptions) => {
    return documents.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::documents
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:523
* @route '/teacher/settings/documents'
*/
documents.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: documents.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::documents
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:523
* @route '/teacher/settings/documents'
*/
documents.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: documents.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::bankDetails
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:620
* @route '/teacher/settings/bank-details'
*/
export const bankDetails = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bankDetails.url(options),
    method: 'get',
})

bankDetails.definition = {
    methods: ["get","head"],
    url: '/teacher/settings/bank-details',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::bankDetails
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:620
* @route '/teacher/settings/bank-details'
*/
bankDetails.url = (options?: RouteQueryOptions) => {
    return bankDetails.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::bankDetails
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:620
* @route '/teacher/settings/bank-details'
*/
bankDetails.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bankDetails.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::bankDetails
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:620
* @route '/teacher/settings/bank-details'
*/
bankDetails.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: bankDetails.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::stripeSession
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:675
* @route '/teacher/settings/stripe-session'
*/
export const stripeSession = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: stripeSession.url(options),
    method: 'post',
})

stripeSession.definition = {
    methods: ["post"],
    url: '/teacher/settings/stripe-session',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::stripeSession
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:675
* @route '/teacher/settings/stripe-session'
*/
stripeSession.url = (options?: RouteQueryOptions) => {
    return stripeSession.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::stripeSession
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:675
* @route '/teacher/settings/stripe-session'
*/
stripeSession.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: stripeSession.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::notifications
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:978
* @route '/teacher/settings/notifications'
*/
export const notifications = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: notifications.url(options),
    method: 'get',
})

notifications.definition = {
    methods: ["get","head"],
    url: '/teacher/settings/notifications',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::notifications
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:978
* @route '/teacher/settings/notifications'
*/
notifications.url = (options?: RouteQueryOptions) => {
    return notifications.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::notifications
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:978
* @route '/teacher/settings/notifications'
*/
notifications.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: notifications.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::notifications
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:978
* @route '/teacher/settings/notifications'
*/
notifications.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: notifications.url(options),
    method: 'head',
})

const settings = {
    index: Object.assign(index, index),
    personalInfo: Object.assign(personalInfo, personalInfo5c22df),
    aboutMe: Object.assign(aboutMe, aboutMe4f841e),
    media: Object.assign(media, media30b75d),
    subjects: Object.assign(subjects, subjectsC258ee),
    levels: Object.assign(levels, levels825db0),
    examboards: Object.assign(examboards, examboards41b059),
    experience: Object.assign(experience, experience39e637),
    teachingDetails: Object.assign(teachingDetails, teachingDetails8077ab),
    pricing: Object.assign(pricing, pricingCf18cb),
    availability: Object.assign(availability, availability135fa0),
    qualifications: Object.assign(qualifications, qualifications98d403),
    documents: Object.assign(documents, documentsC2fd24),
    bankDetails: Object.assign(bankDetails, bankDetails824b2d),
    stripeSession: Object.assign(stripeSession, stripeSession),
    notifications: Object.assign(notifications, notifications1ce82a),
}

export default settings